export default __webpack_public_path__ + "static/media/done.d89a941a.svg";